import { memo } from 'react';

import { PlusIcon } from '@air/design-icons';
import { Button, type ButtonProps } from '@air/primitive-button';
import { DropdownMenu, type DropdownMenuOption, renderDropdownItems } from '@air/primitive-dropdown-menu';

import { type IconType } from '~/types/icons';

type CreateDropdownButtonColor = Extract<ButtonProps['color'], 'blue' | 'gray'>;

export type CreateDropdownButtonProps = {
  'data-testid'?: string;
  /** Optional so legacy callers keep the blue button; ui2026 headers pass 'gray' (WORK-460). */
  color?: CreateDropdownButtonColor;
  icon?: IconType;
  label?: string;
  menuClassName?: string;
  options: DropdownMenuOption[];
};

export const CreateDropdownButton = memo(
  ({
    color = 'blue',
    'data-testid': dataTestId,
    icon: Icon = PlusIcon,
    label = 'Create',
    menuClassName,
    options,
  }: CreateDropdownButtonProps) => {
    if (!options.length) {
      return null;
    }

    return (
      <DropdownMenu
        className={menuClassName}
        size="large"
        trigger={
          <Button
            appearance="filled"
            color={color}
            data-testid={dataTestId}
            prefix={<Icon className="size-4" />}
            size="medium"
          >
            {label}
          </Button>
        }
      >
        {renderDropdownItems({ options, size: 'small' })}
      </DropdownMenu>
    );
  },
);

CreateDropdownButton.displayName = 'CreateDropdownButton';
